import { render } from "./NavBrand.vue?vue&type=template&id=4ed53220"
import script from "./NavBrand.vue?vue&type=script&lang=js"
export * from "./NavBrand.vue?vue&type=script&lang=js"

import "./NavBrand.vue?vue&type=style&index=0&id=4ed53220&lang=scss"

import exportComponent from "/home/jeim2750/staging.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__